import { ID, Int } from '@adornis/baseql/baseqlTypes.js';
import { registerMutation, registerQuery, registerSubscription } from '@adornis/baseql/metadata/register.js';
import { Answer, AnswerErrorReport } from '../db/answer.js';
import {
  getAnswerBySlotIDResolver,
  getAnswerBySlotIDsResolver,
  reportErrorOnAnswerResolver,
  resolveErrorOnAnswerResolver,
  subscribeAnswerBySlotIDsResolver,
} from '../server/resolver/answer.js';

export const getAnswerBySlotID = registerQuery({
  operationName: 'getAnswerBySlotID',
  resolve: getAnswerBySlotIDResolver,
  type: () => Answer,
  params: [{ name: 'slotID', type: () => ID }],
});

export const getAnswerBySlotIDs = registerQuery({
  operationName: 'getAnswerBySlotIDs',
  resolve: getAnswerBySlotIDsResolver,
  type: () => [Answer],
  params: [{ name: 'slotIDs', type: () => [ID] }],
});

export const subscribeAnswerBySlotIDs = registerSubscription({
  operationName: 'subscribeAnswerBySlotIDs',
  resolve: subscribeAnswerBySlotIDsResolver,
  type: () => [Answer],
  params: [
    { name: 'slotIDs', type: () => [ID] },
    { name: 'debounceDuration', type: () => Int },
  ],
});

export const reportErrorOnAnswer = registerMutation({
  operationName: 'reportErrorOnAnswer',
  resolve: reportErrorOnAnswerResolver,
  type: () => Boolean,
  params: [
    { name: 'answerID', type: () => ID },
    { name: 'errorReport', type: () => AnswerErrorReport },
  ],
});

export const resolveErrorOnAnswer = registerMutation({
  operationName: 'resolveErrorOnAnswer',
  resolve: resolveErrorOnAnswerResolver,
  type: () => Boolean,
  params: [
    { name: 'answerID', type: () => ID },
    { name: 'archiveRatingDocs', type: () => Boolean },
  ],
});
